// v2 Vue store router fb App vuetify
import "./plugins/rsw";
import Vue from "vue";
import App from "./App.vue";
import store from "./store/_store";
import fb from "./plugins/fb"; // o fb_android o fb_iOs
import router from "./router";
import infoo from "./plugins/infoo";
import voux from "./plugins/voux";
import localData from "./plugins/localData"; // o localData_android o localData_iOs
import vuetify from "./plugins/vuetify";

// main process
const dev = false;
Vue.config.devtools = dev;
Vue.config.productionTip = !dev;

const ajustarAnchoDialog = function() {
  var h = window.innerHeight;
  var w1 = window.innerWidth;
  var w2 = Math.floor((h / 205) * 134);
  var w = w1 < w2 ? w1 : w2;
  var css =
    ".v-dialog.v-dialog--active.v-dialog--fullscreen.v-dialog--scrollable {max-width: " +
    w +
    "px; position: initial;}";
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.id = "mdd-full-w";
  style.type = "text/css";
  head.appendChild(style);
  style.appendChild(document.createTextNode(css));
};

new Vue({
  router: router,
  store: store,
  vuetify: vuetify,
  infoo: infoo,
  render: h => h(App),
  created() {
    ajustarAnchoDialog();
    // agrega $infoo, $router $voux $fb $local a store
    this.$store.$router = router;
    this.$store.$infoo = infoo;
    this.$store.$voux = voux;
    this.$store.$fb = fb;
    this.$store.$local = localData;

    // agrega $collection a store
    this.$store.$collection = {};
    this.$store.$collection.errors = fb.firestore().collection("errors");
    this.$store.$collection.lectio = fb.firestore().collection("lectio");
    this.$store.$collection.users = fb.firestore().collection("users");

    // agrega $grefs a this / componente vue
    this.$grefs = {};
    this.$grefs.installPrompt = null;

    // el usuario hace login o logout
    // this.$fb.auth().onAuthStateChanged(auth => {
    // this.$store.dispatch("user/authStateChange", auth);
    // });

    //  cargar app
    this.$store.dispatch("app/start");
  }
}).$mount("#app");
